var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpSwipeWeb = function SvgUpSwipeWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 6.44986L24.276 14.7259L22.3907 16.6112L16 10.2205L9.60933 16.6112L7.724 14.7259L16 6.44986ZM16 13.9832L24.276 22.2592L22.3907 24.1445L16 17.7539L9.60933 24.1445L7.724 22.2592L16 13.9832Z"
  })));
};
export default SvgUpSwipeWeb;